import { visitorAtom } from "../../state";
import { createDerivedWritableAtom } from "../../../utils";

export const admissionAttemptsAtom = createDerivedWritableAtom(
  visitorAtom,
  "admissionAttempts",
);

export const joinAttemptsAtom = createDerivedWritableAtom(
  visitorAtom,
  "joinAttempts",
);

export const isAdmissionModalOpenAtom = createDerivedWritableAtom(
  visitorAtom,
  "isAdmissionModalOpen",
);

export const isProviderNotHereModalOpenAtom = createDerivedWritableAtom(
  visitorAtom,
  "isProviderNotHereModalOpen",
);

export const admissionTimeAtom = createDerivedWritableAtom(
  visitorAtom,
  "admissionTime",
);
